module.exports = __webpack_public_path__ + "a7eb3e57807ec310fbb821b6eedeadb6.fbx";